/* eslint-disable eqeqeq */
import {connect} from "react-redux";
import { handleFontSizeChange } from "../../redux/actions/actions.js";

const Profile_Customize_FontSize_Button = (props) => {
    const handleClick = (size) => {
        props.onFontSizeChange(size,props.user.id)
    }
    if (props.size == props.font_size) {
        return (
            <div onClick={()=>handleClick(props.size)} className="profile_customize_section_main_center_button_div" value={props.size} >
                <div className={`profile_customize_section_main_center_button_chosen profile_customize_section_color_button_${props.color_button}`} ></div>
            </div>
        )
    } else if (props.size < props.font_size) {
        return (
            <div onClick={()=>handleClick(props.size)} className="profile_customize_section_main_center_button_div" value={props.size} >
                <div className={`profile_customize_section_main_center_button_unchosen profile_customize_section_color_button_${props.color_button}`} ></div>
            </div>
        )
    } else {
        return (
            <div onClick={()=>handleClick(props.size)} className="profile_customize_section_main_center_button_div" value={props.size} >
                <div className={`profile_customize_section_main_center_button_unchosen profile_customize_section_main_center_button_unchosen_${props.color_button}`} ></div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        color_button: state.getColorButton.color_button,
        font_size: state.getFontSize.font_size,
        user: state.getUser.user
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onFontSizeChange: (size,i) => dispatch(handleFontSizeChange(size,i))  
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Profile_Customize_FontSize_Button);